module.exports = __webpack_public_path__ + "static/media/icon_sentinel_app.a2baee93.png";